import { render, staticRenderFns } from "./DistributionOfTotalCosts.vue?vue&type=template&id=fd6fb21a"
import script from "./DistributionOfTotalCosts.vue?vue&type=script&lang=js"
export * from "./DistributionOfTotalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports